.footer {
  position: relative;
  z-index: 1;
  border-top: 1px solid var(--border);
  padding: 3rem 6vw 2.5rem;
}

.inner {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  gap: 0.5rem 3rem;
  align-items: start;
}

.brand {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.logo {
  font-family: var(--font-display);
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--white);
  text-decoration: none;
  letter-spacing: -0.01em;
  transition: color 0.2s;
}

.logo:hover { color: var(--teal); }

.dot { color: var(--teal); }

.tagline {
  font-family: var(--font-mono);
  font-size: 0.66rem;
  color: rgba(255,255,255,0.2);
  letter-spacing: 0.08em;
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 1.6rem;
  justify-content: flex-end;
  align-items: center;
}

.link {
  font-size: 0.8rem;
  color: rgba(255,255,255,0.3);
  text-decoration: none;
  transition: color 0.2s;
  letter-spacing: 0.03em;
}

.link:hover { color: var(--teal); }

.copy {
  grid-column: 1 / -1;
  font-family: var(--font-mono);
  font-size: 0.65rem;
  color: rgba(255,255,255,0.15);
  letter-spacing: 0.08em;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255,255,255,0.04);
}

@media (max-width: 640px) {
  .footer { padding: 2.5rem 5vw 2rem; }
  .inner { grid-template-columns: 1fr; }
  .links { justify-content: flex-start; margin-top: 1rem; }
}
